import { inject } from 'vue'
import { loggingViewContextKey, type LoggingViewContext } from './logging-view-context'

export default function useLoggingViewContext(): LoggingViewContext {
  const loggingViewContext = inject(loggingViewContextKey)
  if (!loggingViewContext) {
    throw new Error(
      'Logging view context not found. Ensure this component is used within MonitoringView.',
    )
  }
  return loggingViewContext
}
